// Max supported depth is six levels! See i18n-dotize!!
export const en = {
  license: {
    breadcrumbTitle: 'License Check',
    pageTitle: 'Customfield Editor for Jira',
    errorTitle: 'Invalid License',
    errorMessage: 'The app does not have a valid license. Please purchase a license in the Atlassian Marketplace.',
    notice: {
      paragraph1: 'The app does not have a valid license. Please purchase a license in the Atlassian Marketplace.',
    },
  },
  permissions: {
    headline: 'Field:',
    globalPermission: 'Global Permissions',
    contextPermission: 'Context Permissions',
    groupPermissions: 'Group Permissions',
    userPermissions: 'User Permissions',
    editGlobalPermissions: 'Field Global Permissions',
    editContextPermissions: 'Field Context Permissions',
  },
  foo: 'bar',
  global: {
    pageLoadFailErrorHeadline: 'Customfield Editor for Jira',
    pageLoadFailErrorSectionHeadline: 'Unable to access Jira REST API',
    modalCloseFieldEditorLevel: 'Close Level',
    noPermissionsEmptyText: 'No permissions granted',
    help: {
      youCanGetMoreInfo: 'Get more information in the ',
      documentationButton: 'Documentation',
    },
    modalClose: 'Close',
    searchFieldPlaceholder: 'Search',
    permission: {
      groups: 'Groups',
      users: 'Users',
      remove: 'Delete Permission',
    },
    customfieldTypes: {
      select: 'Select List (single choice)',
      cascadingselect: 'Select List (cascading)',
      multiselect: 'Select List (multiple choices)',
      multicheckboxes: 'Checkboxes',
      radiobuttons: 'Radio Buttons',
      textfield: 'Textfield',
      incompatible: 'Incompatible Field Type',
    },
    confirm: {
      yes: 'Yes',
      no: 'No',
    },
    validationError: {
      title: 'Error',
      defaultMessage: 'An unexpected error has occurred [HTTP 400]',
    },
    search: {
      placeholder: 'Search ...',
    },
    product: {
      headline: 'Customfield Editor for Jira',
      titleInfix: 'Customfield Editor for Jira',
      onlineHelp: 'Online Help',
      licenseHelp: 'License Help',
    },
    notFound: {
      pageTitle: 'Not Found',
    },
    navigation: {
      fieldEditor: 'Field Editor',
      permissionEditor: 'Permission Editor',
      adminSettings: 'Admin Settings',
      restApiExplorer: 'REST API Explorer',
    },
    pagination: {
      prevLabel: 'Prev',
      nextLabel: 'Next',
      showingA: 'Showing',
      showingB: 'of',
      showingC: ' results starting with ',
      processedA: 'Processed in',
      processedB: 'ms',
    },
  },
  admin: {
    list: {
      pageTitle: 'Permission Editor',
      subTitle: 'All compatible Customfields',
      breadcrumbTitle: 'Field list',
      tableHead: {
        id: 'ID',
        type: 'Type',
        name: 'Fieldname',
        contexts: 'Contexts',
        permissions: {
          users: 'Users',
          groups: 'Groups',
        },
        projects: 'Projects',
        issueTypes: 'Issue Types',
      },
      globalPermissions: {
        title: 'Global Permissions',
        subTitle: 'Users or Groups granted that permission can work on all contexts.',
      },
      showUsersGroupsButtonLabel: {
        true: 'hide Users/Groups',
        false: 'show Users/Groups',
      },
      viewButtonLabel: 'show field contexts',
      results: {
        noResultsOnFilter: 'Your search led to no results.',
        noResultsWithoutFilter: 'No fields found. There might not exist any compatible fields.',
      },
    },
    edit: {
      pageTitle: 'Permission Editor',
      subTitle: 'Edit Customfield Permissions',
      breadcrumbTitle: 'Edit Field Permissions',
    },
    listContext: {
      pageTitle: 'Permission Editor',
      subTitle: 'Global Permissions',
      breadcrumbTitle: 'Edit Context or Global Permissions',
      tableHead: {
        id: 'ID',
        name: 'Contextname',
      },
    },
  },
  user: {
    list: {
      pageTitle: 'Customfield Editor for Jira',
      subTitle: 'Fields you have access to',
      breadcrumbTitle: 'Customfields',
      notice: {
        paragraph1: 'The Customfield Editor contains all customfields your administrator has granted you permissions for.',
        paragraph2: 'Use the searchbar to filter for customfield ID or name.',
        paragraph3: 'Click on the ___ICON_EDIT___ pen icon to choose the field context you want to edit the options of.',
        admin: {
          paragraph1: 'As an administrator you can grant permissions to normal users.',
          paragraph2: 'Click on the ___ICON_EDIT___ to grant users or groups permissions on a specific context of the field.',
          paragraph3: 'Or click on the ___ICON_USERGROUP___ to grant users or groups permissions on all contexts of the field.',
        },
      },
      fieldIsLocked: 'The field is locked by Jira or another App and cannot be edited.',
      fieldIsNotCompatible: 'The field type is not compatible and cannot be edited.',
      hasGlobalPermission: {
        title: 'Permissions',
        yes: 'You have global permission and can work on all contexts.',
        no: 'You have permissions to work on specific contexts.',
      },
      tableHead: {
        id: 'ID',
        type: 'Type',
        name: 'Fieldname',
        contexts: 'Contexts',
        projects: 'Projects',
        issueTypes: 'Issue Types',
        permission: 'Permission',
      },
      editButtonLabel: 'Field Contexts',
      editOptionsButton: 'Edit Options',
      results: {
        noResultsOnFilter: 'Your search led to no results',
        noResultsOnFilterDescription: 'Try to type in another search phrase or clear the search filter.',
        noResultsWithoutFilter: 'No customfields found',
        noResultsWithoutFilterDescription: 'Ask your administrator to grant you field permissions.',
      },
      noContextInCustomfield: {
        title: 'no context present',
        details: 'A customfield without a context is not editable. Ask your Jira administrator to create a Default or Project Context.',
      },
    },
    editOptions: {
      breadcrumbTitle: 'Edit Options',
    },
    edit: {
      pageTitle: 'Edit Customfield Options',
      notice: '',
    },
    restApi: {
      pageTitle: 'REST API Explorer',
    },
    listContext: {
      pageTitle: 'Field Editor',
      subTitle: 'Contexts',
      breadcrumbTitle: 'Contexts',
      notice: {
        paragraph1: 'Every Customfield has one or more contexts.',
        paragraph2: 'A context can be assigned to one or more projects or issue types.',
        paragraph3: 'Click on the ___ICON_EDIT___ pen icon to choose the field context you want to edit the options of.',
        admin: {
          paragraph1: 'As an administrator you can grant permissions to normal users.',
          paragraph2: 'Click on the ___ICON_USERGROUP___ to grant users or groups permissions on a specific context of the field.',
        },
      },
      tableHead: {
        id: 'ID',
        name: 'Contextname',
      },
      results: {
        noResultsOnFilter: 'Your search led to no results',
        noResultsOnFilterDescription: 'Try to type in another search phrase or clear the search filter.',
        noResultsWithoutFilter: 'No contexts found',
        noResultsWithoutFilterDescription: 'The field has no contexts or you do not have field permissions.',
      },
    },
  },
  rest: {
    http: {
      errorLabel: 'Error',
      errorDesc: 'Data could not be transmitted via REST API.',
    },
    validation400: {
      errorLabel: 'Validation Error',
      errorDesc: '---',
    },
    invalidlicense: {
      errorLabel: 'App license problem',
    },
    gatewaytimeout504: {
      errorLabel: 'Error',
      errorDesc: 'The app is not able to call the REST API. Try reloading the page.',
    },
    unauthorized401: {
      errorLabel: 'Error',
      errorDesc: 'The app is not able to call the REST API. Are you logged in? Try reloading the page.',
    },
    forbidden403: {
      errorLabel: 'Error',
      errorDesc: "You don't have permissions to access this page.",
    },
  },
  permissionEditorListPage: {
    notice: {
      paragraph1: 'The Permission Editor shows all supported customfields with their permissions.',
      paragraph2: 'Use the searchbar to filter for customfield ID, name or description.',
      paragraph3:
        'Click on the ___ICON_EDIT___ pen icon to grant users and groups global permissions or context specific permissions. Users and group members with permissions can edit customfield options by themselves.',
      paragraph4: 'Click on the ___ICON_USERGROUP___ show Users/Groups Icon to get a quick overview of already granted permissions.',
    },
    globalPermission: {
      isSet: 'Global Permissions are granted',
      isNotSet: 'No Global Permissions are granted',
    },
    contextPermission: {
      isSet: 'Context Permissions are granted',
      isNotSet: 'No Context Permissions are granted',
    },
  },
  editPermissionsPage: {
    noContextInCustomfield: {
      title: 'no context present',
      details: 'A customfield without a context is not editable for users in the Field Editor. Create a Default or Project Context via the Jira administration page for customfields.',
    },
    placeholders: {
      groupPermissions: 'Groups',
      userPermissions: 'Users',
      typeToSeeUsers: 'Start typing to search for users',
      typeToSeeGroups: 'Start typing to search for groups',
    },
    emptyMessage: {
      groupTitle: 'No permissions granted',
      groupDescription: 'Start typing to search for groups to grant permissions.',
      userTitle: 'No permissions granted',
      userDescription: 'Start typing to search for users to grant permissions.',
    },
    globalPermissions: {
      notice: {
        paragraph1:
          'Edit customfield permissions and grant global permissions to users and groups. Global permissions apply to all contexts of the chosen customfield. The authorized users and group members will be able to modify customfield options in any way:',
        paragraph2: 'Add new options, edit existing options, delete options, enable/disable options and order options.', // FIXME: sort options alphabetically and set a default value.',
      },
    },
    contextPermissions: {
      notice: {
        paragraph1:
          'Edit customfield permissions and grant context permissions to users and groups. Context permissions apply to a specific context of the chosen customfield. The authorized users and group members will be able to modify customfield options in any way:',
        paragraph2: 'Add new options, edit existing options, delete options, enable/disable options and order options.', // FIXME: , sort options alphabetically and set a default value.',
        paragraph3: 'If you have defined global permissions for a user or group, your specific context permissions for that user or group will be overruled.',
      },
    },
  },
  fieldEditor: {
    emptyOptionsListMessage: 'There are no customfield options yet.',
    scrollToTop: 'To top',
    scrollToBottom: 'To bottom',
    notice: {
      paragraph1: 'Edit customfield options according to your needs:',
      paragraph2: 'Add new options, edit existing options or delete options.',
      paragraph3: 'Enable options or disable the options you want to hide in Jira Issue.',
      paragraph4: 'Simply change the order by drag and drop; the order will be used in Jira Issue.',
      paragraph5: 'Set the ___ICON_DEFAULT___ default value for pre-selection in Jira Issue.',
    },
    editChildOptions: 'Edit Child Options',
    defaultOptionIsSetInChildOptions: 'Set the default value in the child options',
    deleteDefaultOptionButton: 'Delete default value',
    editConfirm: {
      yes: 'Confirm edit',
      no: 'Cancel edit',
    },
    deleteConfirm: {
      yes: 'Confirm delete',
      no: 'Cancel delete',
      tooltip: 'Delete option',
      tooltipDisabledDuePermission: 'Delete option disabled (only enabled for administrators)',
    },
    editOption: {
      duplicateError: 'Option already exists. Options have to be unique.',
      duplicateErrorShort: 'duplicate',
    },
    table: {
      optionvalue: 'Option value',
      default: 'Default',
      disabled: 'Enabled',
      childoptions: 'Child opt.',
    },
    defaultOption: {
      tooltip: 'Show current Default Value',
      headline: 'Default Value',
      isNotDefault: 'Set default value',
      isDefault: 'Is already default value',
      noDefaultValue: '- no default value -',
      types: {
        select: 'Radio Buttons: has single option as default value.',
        radiobuttons: 'Select List (single choice): has single option as default value.',
        multiselect: 'Select List (multiple choices): has multiple options as default value.',
        multicheckboxes: 'Checkboxes: Has multiple options as default value.',
        cascadingselect:
          'Select List (cascading): Each option can have childoptions. Has a single compound default value consisting of a parent option and a child option. The child option is optional.',
      },
    },
    newOption: {
      addButton: 'Add',
      placeholder: 'Add new option',
    },
    refresh: 'Refresh',
    sort: {
      headline: 'Sort Options alphabetically in the Database',
      strength: {
        title: 'Strength',
        titleTooltip: 'Defines how similar characters are treated while sorting. If you are unsure, leave it on default.',
        primary: 'Accents equal, Case equal (a = ä, a = A)',
        secondary: 'Accents unequal, Case equal (a != ä, a = A)',
        tertiary: 'Accents unequal, Case unequal (a != ä, a != A)',
      },
      order: {
        title: 'Order',
        titleTooltip: 'Define if list should be sorted A to Z (ascending) or Z to A (descending).',
        ascending: 'ascending',
        descending: 'descending',
      },
      locale: {
        title: 'Locale',
        titleTooltip: "Sorting is language specific. Define a locale that corresponds to option values' language. In ISO 639 format like en-US.",
      },
      buttonDoSort: 'Sort',
    },
  },
};
